const styles = {
  container: {
    height: "64px",
    width: "32px",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 3px 0 rgba(0,0,0,0.2)",
    zIndex: "800",
    "@media screen and (max-width : 1200px)": {
      display: "none",
    },
  },
  inOut: {
    height: "31.5px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      "& g": {
        fill: "#051D39",
      },
    },
  },
  dividerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  divider: {
    boxSizing: "border-box",
    height: "1px",
    width: "18px",
    border: "1px solid #B4BBC3",
    backgroundColor: "#D8D8D8",
  },
  // Portrait
  "@media screen and (max-width : 767px), (max-width : 1200px) and (orientation: portrait)": {
    container: {},
  },
  // Landscape
  "@media screen and (max-width : 767px), (max-width : 1200px) and (orientation: landscape)": {
    container: {},
  },
};

export default styles;
